import { Controller } from "@hotwired/stimulus"

// Toggles accordion sections on mobile (payment mode, shipping)
export default class extends Controller {
  static targets = ["body", "chevron"]
  static values = { autoOpen: { type: Boolean, default: false } }

  connect() {
    if (this.autoOpenValue) {
      this.open()
    }
  }

  toggle() {
    if (this.bodyTarget.classList.contains("ps-accordion-body--open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.bodyTarget.classList.add("ps-accordion-body--open")
    this.chevronTarget.classList.add("ps-accordion-chevron--open")
  }

  close() {
    this.bodyTarget.classList.remove("ps-accordion-body--open")
    this.chevronTarget.classList.remove("ps-accordion-chevron--open")
  }
}
